
export default {
  jackpots: [],
  winners: [],
}